export default function BenefitCard({ item, index }) {
  const { title, text, Icon } = item;
  const SafeIcon = Icon || (() => null);

  return (
    <article
      className={`benefit-card reveal-on-scroll reveal-on-scroll--scale reveal-delay-${
        (index % 4) + 1
      }`}
    >
      <span className="benefit-card__index">
        {String(index + 1).padStart(2, "0")}
      </span>

      <div className="benefit-card__icon">
        <SafeIcon />
      </div>

      <div className="benefit-card__content">
        <h3>{title}</h3>
        <div className="benefit-card__line" />
        <p>{text}</p>
      </div>
    </article>
  );
}